import {Component, computed, inject, input, OnInit, signal} from '@angular/core'
import {InputField} from '../../../input-field/input-field'
import {MatButton, MatIconButton} from '@angular/material/button'
import {MatIcon} from '@angular/material/icon'
import {INewOwner} from '../new-case'
import {DataService} from '../../../../services/data-service'
import {applyEach, form, maxLength, minLength, required} from '@angular/forms/signals'
import {personNummer} from '@sparbanken-syd/sparbanken-syd-theme'

const getOwner = (org = false, sub = '', name = ''): INewOwner => ({
  name,
  sub,
  org
})


@Component({
  selector: 'spb-new-case-id-list',
  imports: [
    InputField,
    MatButton,
    MatIcon,
    MatIconButton
  ],
  templateUrl: './new-case-id-list.html',
  styleUrl: './new-case-id-list.scss'
})
export class NewCaseIdList implements OnInit {

  /**
   * Set to true to make this Organisationsnummer instead of personnummer
   */
  public org = input<boolean>(false)

  public owners = signal<INewOwner[]>([])

  // Extract to test it
  public minLen = computed(() => this.org() ? 0 : 1)
  /**
   * Create an empty form so that we can set validators once inputs
   * have stabilized
   */
  public ownerForm = form(this.owners, l => {
    minLength(l, () => this.minLen())
    applyEach(l, p => {
      required(p.sub)
      minLength(p.sub, 10) // Important since the validator do not validate < 10
      maxLength(p.sub, 13)
      // Personnummer does not take a function so we cannot bind this.org() in runtime.
      personNummer(p.sub, {mustBeOver18: false, canBeOrg: true})

    })
  })

  private readonly service = inject(DataService)


  /**
   * Needed since the template does not recognize the item
   * as an array
   */
  get formIterable(): Iterable<any> {
    return this.owners()
  }

  public ngOnInit() {
    this.owners.update(os => os.concat(getOwner(this.org())))
    if (!this.org()) {
      this.owners()[0].sub = this.service.ovUser() ?? ''
    }
  }

  public add(sub = '', name = '') {
    this.owners.update(os => os
      .filter(o => !!o.sub)
      .concat(getOwner(this.org(), sub, name)))
  }

  public remove(idx: number) {
    this.owners.update(os => os.toSpliced(idx, 1)) // Why new array?
  }
}
